import { useState } from "react";
import { NAV_ITEMS, STUDIO_NAME } from "../content/site-content.js";
import { trackClickThrough } from "../lib/use-site-tracker.js";

/**
 * Fixed top navigation (Req 1.2 wayfinding): brand mark plus in-page anchors
 * to GALLERY / INVESTMENT / ABOUT / FAQs / BOOK.
 *
 * On narrow screens the links collapse behind a hamburger toggle that opens a
 * full-width dropdown, so the links never overflow/clip off the side.
 *
 * Each link also reports a click-through (`nav:<id>`) for the Owner's insights;
 * the call cannot throw, so navigation is never affected (Req 2.4, 14.5).
 */
export function Nav(): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav" aria-label="Primary">
      <a
        className="nav__brand"
        href="#hero"
        onClick={() => {
          trackClickThrough("nav:brand");
          setOpen(false);
        }}
      >
        {STUDIO_NAME}
      </a>

      <button
        type="button"
        className="nav__toggle"
        aria-expanded={open}
        aria-controls="primary-nav-links"
        aria-label={open ? "Close menu" : "Open menu"}
        onClick={() => setOpen((current) => !current)}
      >
        <span aria-hidden="true">{open ? "\u2715" : "\u2630"}</span>
      </button>

      <ul
        id="primary-nav-links"
        className={open ? "nav__links nav__links--open" : "nav__links"}
      >
        {NAV_ITEMS.map((item) => (
          <li key={item.id}>
            <a
              className="nav__link"
              href={`#${item.id}`}
              onClick={() => {
                trackClickThrough(`nav:${item.id}`);
                setOpen(false);
              }}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
